<template>
    <svg :width="width" :height="height" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_110_12979)">
            <path d="M11.4399 11.9946L14.8213 15.3242L26.3483 3.97358L22.967 0.643946L11.4399 11.9946Z" :stroke="color"
                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20.7592 2.81489L24.1406 6.14453L26.307 4.01129L22.9256 0.681651L20.7592 2.81489Z" :stroke="color"
                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.81836 17.0734L14.7275 15.4884L11.4134 12.1953L9.81836 17.0734Z" :stroke="color" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linejoin="round" />
            <path
                d="M11.8685 3.04688H6.89976C5.46155 3.04688 4.29492 4.20486 4.29492 5.63524V19.9707C4.29492 21.3998 5.46028 22.5591 6.89976 22.5591H21.3264C22.7647 22.5591 23.9313 21.4011 23.9313 19.9707V15.0334"
                :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
        </g>
        <defs>
            <clipPath id="clip0_110_12979">
                <rect width="27" height="25" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'EditSvg',
    props: {
        color: {
            type: String,
            default: '#00B1DB',
        },
        width: {
            type: Number,
            default: 27,
        },
        height: {
            type: Number,
            default: 25,
        },
    },
}
</script>
